export enum ScreeningType {
  ResumeScreening = 'resume_screening',
  JobInterview = 'job_interview'
}

export function getScreeningTypeLabel(type: ScreeningType): string {
  switch (type) {
    case ScreeningType.ResumeScreening:
      return 'Candidate Interview';
    case ScreeningType.JobInterview:
      return 'Job Interview';
    default:
      return 'Unknown';
  }
}

export function getScreeningTypeColor(type: ScreeningType): string {
  switch (type) {
    case ScreeningType.ResumeScreening:
      return 'warning.300';
    case ScreeningType.JobInterview:
      return 'primary.100';
    default:
      return 'gray.400';
  }
}
